export interface FavoriteTool {
  id: number;
  name: string;
  category: string;
}

export interface RecommendedTool {
  id: number;
  name: string;
  reason: string;
}

export const favoriteTools: FavoriteTool[] = [
  { id: 1, name: "ChatGPT", category: "Chatbots" },
  { id: 2, name: "Midjourney", category: "Image Generation" },
  { id: 3, name: "Notion AI", category: "Productivity" }
];

export const recommendedTools: RecommendedTool[] = [
  { id: 4, name: "Claude", reason: "Similar to ChatGPT" },
  { id: 6, name: "DALL-E", reason: "Similar to Midjourney" },
  { id: 8, name: "Grammarly", reason: "Based on your interest in writing tools" }
];
